import useMediaQuery from '@mui/material/useMediaQuery';

export default () => useMediaQuery('(max-width: 768px)');
